import { Stack } from 'components/Stack'
import Image, { StaticImageData } from 'next/image'
import { Text } from 'components/Text'
import {
  FooterMessageRoot,
  FooterCard,
  TextColumn,
  Title,
  ImageWrapper,
  CardShadow,
  FooterContainer,
} from './FooterMessage.styles'
import { Box } from 'components/Box'
import Trans from 'next-translate/Trans'
import { TranslationKeys } from 'locales/translationKeys'
import { useTranslation } from 'hooks/useTranslation'

type FooterMessageProps = {
  imageAlt: TranslationKeys
  imageSrc: StaticImageData
  title: TranslationKeys
  subtext: TranslationKeys
  step: '1' | '2' | '3'
}

export const FooterMessage = (props: FooterMessageProps) => {
  const { imageSrc, imageAlt, title, subtext, step } = props
  const { t } = useTranslation()
  return (
    <FooterMessageRoot>
      <FooterContainer>
       <FooterCard>
        <ImageWrapper step={step}>
          <Image objectFit='cover' layout='fill' src={imageSrc} alt={imageAlt} />
        </ImageWrapper>
        <TextColumn direction="column" alignItems="flex-start">
            <Title>{t(title)}</Title>
          <Text color="accent-black" size="headline">
            <Trans i18nKey={subtext} components={{ span: <strong /> }} />
          </Text>
        </TextColumn>
      </FooterCard>
      <CardShadow /> 
      </FooterContainer>
    </FooterMessageRoot>
  )
}
